import React, { useContext } from "react"
import Slider from "react-slick"
import { UIContext } from "../../../components/shared/layout"

import {
  LightboxWrapper,
  LightboxControls,
  LightboxContentWrapper,
} from "./lightbox.styles"

const SliderLightbox = ({ children, toggle, index = 0 }) => {
  const {
    state: { clientLoaded },
  } = useContext(UIContext)

  return (
    <LightboxWrapper>
      <LightboxControls>
        <button onClick={toggle}>Close</button>
      </LightboxControls>
      {clientLoaded && (
        <LightboxContentWrapper onClick={toggle}>
          <div
            onClick={e => {
              e.stopPropagation()
            }}
          >
            <Slider initialSlide={index}>{children}</Slider>
          </div>
        </LightboxContentWrapper>
      )}
    </LightboxWrapper>
  )
}

export default SliderLightbox
